export default "__VITE_ASSET__620a4a9b__"